import React, { useEffect, useState } from "react";
import SideNavSC from "./sidenav.styles";

const MENU = [
    { id: "YourCounselor", label: "Your Counselor", icon: "🧠" },
    { id: "MemorableMoments", label: "Memorable Moments", icon: "📸" },
    { id: "CommunityContributions", label: "Community Contributions", icon: "🤝" },
    { id: "Testimonials", label: "Testimonials", icon: "💖" },
    { id: "PeerGroup", label: "Join Peer Group", icon: "🤗" },
    { id: "FAQ", label: "FAQ", icon: "❓" },
    { id: "EmergencyContact", label: "Emergency Contact", icon: "🚨" }
];

export default function SideNav({ onSelect, visible }) {
    const [active, setActive] = useState("dashboard");

    const handleClick = (item) => {
        setActive(item.id);
        onSelect && onSelect(item.id);
    };

    return (
        <SideNavSC>
            <div className='sidebar' style={{
                opacity: visible ? 1 : 0,
                transform: visible ? "scale(1)" : "scale(0.95)",
                visibility: visible ? "visible" : "hidden"
            }}>

                {/* Header */}
                <div className='header'>
                    <div className="title">Niraatanka</div>
                </div>

                <div className='divider'></div>

                {/* Menu */}
                <div>
                    {MENU.map((item) => {
                        const isActive = active === item.id;

                        return (
                            <div
                                key={item.id}
                                onClick={() => handleClick(item)}
                                className={`menu-item ${isActive ? 'active-item' : ''}`}
                            >
                                <span className='icon'>{item.icon}</span>
                                {item.label}
                            </div>
                        );
                    })}
                </div>

            </div>
        </SideNavSC >
    );
}